import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';


@Component({components:{}})
export default class MergiLaSigur extends Vue {
    loading:boolean=false;
    evenimentMobilSlide='aniversare';

    $refs:any;
    private userStore=getModule(User);



    constructor(){
        super();
    }




}
